export default "__VITE_ASSET__ZIAjB7VS__"